
import $ from 'jquery';

$('a[href*=\\#]:not([href=\\#])').on('click', function () {
  if (!$(this).hasClass("js-header-line")) {
    if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      && location.hostname == this.hostname) {
      let $target = $(this.hash);
      $target = $target.length && $target || $('[name=' + this.hash.slice(1) + ']');
      let offsetTop = $(".c-header").outerHeight();
      if ($target.length) {
        let targetOffset = $target.offset().top - offsetTop;
        $('html,body').animate({ scrollTop: targetOffset }, 1000);
        return false;
      }
    }
  }
});

let target = window.location.hash;
target = target.replace('#', '');
window.location.hash = "";
$(window).on('load', function () {
  if (target) { $("html, body").animate({ scrollTop: $("#" + target).offset().top - $('.c-header').outerHeight() }, 1000, 'swing', function () { }); }
});

$('.js-header-line').on('click', function (e) {
  let hashIndex = $(this).attr('href').split('#')[1];
  if ($('.c-header').hasClass('is-show')) {
    $('.c-navbar2.js-navbar').trigger('click');
  }
  setTimeout(function () {
    $('html, body').animate(
      {
        scrollTop:
          $('#' + hashIndex).offset().top - $('.c-header').outerHeight(),
      }, 1000, 'swing',
      function () { },
    );
  }, 400);
});